import { Language, TText } from "api/type";
import { LanguageContext } from "contexts";
import React, { useContext } from "react";

const text: TText = {
  text1: {
    en: "Camera Access",
    es: "Acceso a la cámara",
  },
  text2: {
    en: "Enable your camera to continue personalize visualization.",
    es: "Habilita tu cámara para continuar con la visualización personalizada.",
  },
  text3: {
    en: "You can enable it in your setting afterwards, or try different device or browser to use it.",
    es: "Puede habilitarlo en su configuración posteriormente, o intentar con un dispositivo o navegador diferente para usarlo.",
  },
};

const CameraAccessError: React.FC = () => {
  const language = useContext<Language>(LanguageContext)[0];

  if (!language) return null;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "700",
          textAlign: "center",
          padding: 0,
          margin: 0,
        }}
      >
        {text.text1[language]}
      </h1>
      <img
        src="https://clinic-os.com/flow-assets%2Fcamera-access.png"
        alt="Camera Access Error"
      />
      <span
        style={{ fontSize: "20px", fontWeight: "700", textAlign: "center" }}
      >
        {text.text2[language]}
      </span>
      <span style={{ textAlign: "center", marginBottom: "10px" }}>
        {text.text3[language]}
      </span>
    </div>
  );
};

export default CameraAccessError;
